import { render, staticRenderFns } from "./PopupTextSkeleton.vue?vue&type=template&id=a9487b02&scoped=true"
import script from "./PopupTextSkeleton.vue?vue&type=script&lang=js"
export * from "./PopupTextSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9487b02",
  null
  
)

export default component.exports